import * as actionTypes from '../constants/searchInfoConstants'
import {COMMON_SEARCH_CONDITION} from "../config/localStoreKey";


const initialState =
    {
        // 查询图书信息
        bookList: {data: [], pageCount: 0, currentPage: 0},
        // 书架信息页面展示
        bookAddressStyle: {display: 'none'},
        //普通 查询条件
        condition: undefined,
        //普通查询历史条件
        conditionHistory: [],
        // 高级查询条件
        advanceCondition: undefined,
        // 查询状态 即是什么类型的查询
        searchCondition: COMMON_SEARCH_CONDITION,
        // 查询的图书的位置
        bookPosition: [],
    };

export default function searchInfo(state = initialState, action) {
    switch (action.type) {
        // 图书检索
        case actionTypes.BOOK_SEARCH:
            return action.data;

        // 高级检索
        case actionTypes.ADVANCED_SEARCH:
            return action.data;

        // 查询状态
        case actionTypes.SEARCH_CONDITION:
            return action.data;

        // 上一页
        case actionTypes.PREVIOUS_PAGE:
            return action.data;

        // 下一页
        case actionTypes.NEXT_PAGE:
            return action.data;

        // 图书馆信息位置展示
        case actionTypes.BOOK_ADDRESS:
            return action.data;
        // 图书信息 删除
        case actionTypes.UNDO_BG:
            return action.data;

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/searchInfo.js